
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryItems = [
    {
      id: 1,
      image: 'https://static.readdy.ai/image/6c2cafd9ce757604804cd434f1092eb5/1f8ce2545a12634edbda069c35533e61.jpeg',
      title: 'Luxury Vehicle Restoration - Rolls Royce',
      category: 'Luxury Repair'
    },
    {
      id: 2,
      image: 'https://public.readdy.ai/ai/img_res/3f4c11d4b52fa35a964f158b7a58a8c3.jpg',
      title: 'Collision Repair - Red Sedan',
      category: 'Collision Repair'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20auto%20body%20paint%20work%20showing%20a%20blue%20SUV%20with%20perfect%20glossy%20paint%20finish%20in%20a%20professional%20Brooklyn%20auto%20body%20shop%20with%20clean%20white%20background%20highlighting%20expert%20paint%20and%20body%20work%20quality&width=800&height=600&seq=gallery2&orientation=landscape',
      title: 'Paint & Body Work - Blue SUV',
      category: 'Paint Work'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=professional%20auto%20body%20dent%20removal%20work%20showing%20a%20silver%20luxury%20car%20with%20perfectly%20smooth%20panels%20in%20a%20modern%20Brooklyn%20auto%20body%20shop%20with%20bright%20lighting%20and%20clean%20white%20background%20demonstrating%20expert%20dent%20repair%20skills&width=800&height=600&seq=gallery3&orientation=landscape',
      title: 'Dent Removal - Silver Luxury Car',
      category: 'Dent Repair'
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=expert%20auto%20body%20frame%20straightening%20work%20showing%20a%20black%20pickup%20truck%20with%20perfectly%20aligned%20frame%20in%20a%20professional%20Brooklyn%20auto%20body%20shop%20with%20clean%20white%20background%20showcasing%20structural%20repair%20expertise&width=800&height=600&seq=gallery4&orientation=landscape',
      title: 'Frame Repair - Black Pickup',
      category: 'Frame Work'
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=professional%20auto%20body%20bumper%20repair%20work%20showing%20a%20white%20compact%20car%20with%20perfectly%20restored%20front%20bumper%20in%20a%20modern%20Brooklyn%20auto%20body%20shop%20with%20bright%20lighting%20and%20clean%20white%20background%20highlighting%20expert%20bumper%20repair%20quality&width=800&height=600&seq=gallery5&orientation=landscape',
      title: 'Bumper Repair - White Compact',
      category: 'Bumper Work'
    },
    {
      id: 7,
      image: 'https://readdy.ai/api/search-image?query=expert%20auto%20body%20scratch%20removal%20work%20showing%20a%20gray%20sports%20car%20with%20flawless%20paint%20surface%20in%20a%20professional%20Brooklyn%20auto%20body%20shop%20with%20clean%20white%20background%20demonstrating%20expert%20scratch%20repair%20and%20paint%20matching%20skills&width=800&height=600&seq=gallery6&orientation=landscape',
      title: 'Scratch Removal - Gray Sports Car',
      category: 'Paint Correction'
    },
    {
      id: 8,
      image: 'https://readdy.ai/api/search-image?query=professional%20auto%20body%20door%20panel%20replacement%20work%20showing%20a%20green%20sedan%20with%20perfectly%20fitted%20new%20door%20in%20a%20modern%20Brooklyn%20auto%20body%20shop%20with%20bright%20lighting%20and%20clean%20white%20background%20showcasing%20expert%20panel%20replacement%20quality&width=800&height=600&seq=gallery7&orientation=landscape',
      title: 'Door Panel Replacement - Green Sedan',
      category: 'Panel Work'
    },
    {
      id: 9,
      image: 'https://readdy.ai/api/search-image?query=expert%20auto%20body%20hail%20damage%20repair%20work%20showing%20a%20silver%20minivan%20with%20perfectly%20smooth%20roof%20and%20hood%20in%20a%20professional%20Brooklyn%20auto%20body%20shop%20with%20clean%20white%20background%20demonstrating%20expert%20hail%20damage%20repair%20skills&width=800&height=600&seq=gallery8&orientation=landscape',
      title: 'Hail Damage Repair - Silver Minivan',
      category: 'Hail Repair'
    },
    {
      id: 10,
      image: 'https://readdy.ai/api/search-image?query=professional%20auto%20body%20fender%20repair%20work%20showing%20a%20burgundy%20coupe%20with%20perfectly%20restored%20fender%20in%20a%20modern%20Brooklyn%20auto%20body%20shop%20with%20bright%20lighting%20and%20clean%20white%20background%20highlighting%20expert%20fender%20repair%20craftsmanship&width=800&height=600&seq=gallery9&orientation=landscape',
      title: 'Fender Repair - Burgundy Coupe',
      category: 'Fender Work'
    }
  ];

  const categories = ['All', ...Array.from(new Set(galleryItems.map(item => item.category)))];
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredItems = activeCategory === 'All' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === activeCategory);

  return (
    <>
      <SEOHead
        title="Before & After Gallery - Brooklyn Auto Body Shop | Collision Repair Portfolio"
        description="View our before and after gallery of completed auto body repair, collision repair, and paint work projects in Brooklyn, NY. See the quality craftsmanship and expert results from our 30+ years of experience."
        keywords="auto body gallery Brooklyn, collision repair portfolio, paint work examples, before after auto repair, Brooklyn auto body work"
        canonicalUrl="/gallery"
        schemaData={{
          '@context': 'https://schema.org',
          '@type': 'ImageGallery',
          name: 'Brooklyn Auto Body Shop Gallery',
          description: 'Portfolio of completed auto body repair and collision work',
          provider: {
            '@type': 'AutoRepair',
            name: 'Brooklyn Auto Body Shop',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '4001 2nd Avenue',
              addressLocality: 'Brooklyn',
              addressRegion: 'NY',
              postalCode: '11232',
              addressCountry: 'US'
            },
            telephone: '+16319337887'
          }
        }}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        
        {/* Hero Section */}
        <section className="relative pt-24 sm:pt-32 pb-12 sm:pb-20 bg-gradient-to-br from-orange-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="text-center max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-2 rounded-full mb-4 sm:mb-6">
                <i className="ri-gallery-fill text-lg"></i>
                <span className="text-sm font-semibold whitespace-nowrap">Before & After</span>
              </div>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-['Playfair_Display'] px-4">
                Our Work Gallery
              </h1>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed px-4">
                Explore our portfolio of completed projects showcasing expert collision repair, paint work, and restoration services. Over 30 years of quality craftsmanship in Brooklyn.
              </p>
            </div>
          </div>
        </section>

        {/* Filter Section */}
        <section className="py-6 sm:py-8 border-b border-gray-200 bg-white sticky top-16 sm:top-20 z-40">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setActiveCategory(category)}
                  className={`px-4 sm:px-6 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === category
                      ? 'bg-orange-600 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="py-12 sm:py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {filteredItems.map((item) => (
                <div
                  key={item.id}
                  className="group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
                  onClick={() => setSelectedImage(item.image)}
                >
                  <div className="relative w-full h-64 sm:h-80 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
                        <span className="inline-block px-3 py-1 bg-orange-600 text-white text-xs font-semibold rounded-full mb-2">
                          {item.category}
                        </span>
                        <h3 className="text-white font-bold text-base sm:text-lg">{item.title}</h3>
                        <p className="text-white/80 text-xs sm:text-sm mt-2">Click to view full size</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 sm:p-5">
                    <span className="inline-block px-3 py-1 bg-orange-100 text-orange-700 text-xs font-semibold rounded-full mb-2">
                      {item.category}
                    </span>
                    <h3 className="font-bold text-gray-900 text-sm sm:text-base">{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 sm:py-20 bg-gradient-to-br from-orange-600 to-orange-700">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4 sm:mb-6 font-['Playfair_Display'] px-4">
              Ready to Restore Your Vehicle?
            </h2>
            <p className="text-lg sm:text-xl text-white/90 mb-6 sm:mb-8 leading-relaxed px-4">
              Let our expert team bring your car back to perfect condition. Contact us today for a free estimate.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 px-4">
              <a
                href="tel:+16319337887"
                className="w-full sm:w-auto bg-white text-orange-600 px-8 py-4 rounded-full text-base font-bold hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-phone-fill mr-2"></i>
                Call (631) 933-7887
              </a>
              <a
                href="/contact"
                className="w-full sm:w-auto bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-base font-bold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Get Free Estimate
              </a>
            </div>
          </div>
        </section>

        <Footer />
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 sm:top-6 sm:right-6 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white text-xl sm:text-2xl transition-colors cursor-pointer z-10"
            onClick={() => setSelectedImage(null)}
            aria-label="Close preview"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={selectedImage}
            alt="Gallery preview"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};

export default GalleryPage;
